import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import UnifiedDateTime from '../../../utils/UnifiedDateTime'

interface Props {
  expiresAt?: string
}

const HeaderContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s200};
  margin-top: ${minus(cssTheme.layout.spacing.s500)};
  align-items: center;

  &.__isMobile {
    align-items: center;
    text-align: center;
  }
`

export const HeaderContent = ({expiresAt}: Props) => {
  const {isMobile} = useDeviceLayout()

  return (
    <HeaderContentWrapper className={cx(isMobile && '__isMobile')}>
      <Text colorPath="content.highlight.c500" variant="titleXL">
        <FormattedMessageWrapper
          id="dealFreeze.confirmationOverlayHeader"
          defaultMessage="Deal secured!"
        />
      </Text>

      {expiresAt && (
        <Text variant="bodyM" colorPath="content.neutral.c000" align="center">
          <FormattedMessageWrapper
            id="dealFreeze.confirmationOverlaySubHeader"
            defaultMessage="The price and availability are now guaranteed until <br></br> {expirationDate}. Book when you’re ready."
            values={{
              expirationDate: (
                <UnifiedDateTime value={expiresAt} format={'date-longform'} />
              ),
              br: () => <br />
            }}
          />
        </Text>
      )}
    </HeaderContentWrapper>
  )
}
